/**
 * @fileoverview Some labels to the magic numbers related to AuthenticationSubject.CONSUMER.
 *
 * Some if not all of these can be found on this WIP confluence table:
 * {@link https://confluence.mastercard.int/x/v1L8LQ#FrontEnd::LiabilityShiftSDKParameters-VerificationData.1}
 *
 * TODO: Move to `@mc-alberta/types` repo once finalized.
 */
export var ConsumerVerificationEntity;
(function (ConsumerVerificationEntity) {
    ConsumerVerificationEntity["SRC_SYSTEM"] = "02";
    ConsumerVerificationEntity["SRCPI"] = "03";
})(ConsumerVerificationEntity || (ConsumerVerificationEntity = {}));
export var ConsumerVerificationEvents;
(function (ConsumerVerificationEvents) {
    ConsumerVerificationEvents["SRC_PROFILE_ACCESS"] = "03";
})(ConsumerVerificationEvents || (ConsumerVerificationEvents = {}));
export var ConsumerVerificationMethods;
(function (ConsumerVerificationMethods) {
    ConsumerVerificationMethods["SMS_OTP"] = "02";
    ConsumerVerificationMethods["EMAIL_OTP"] = "05";
    ConsumerVerificationMethods["FIDO2"] = "12";
})(ConsumerVerificationMethods || (ConsumerVerificationMethods = {}));
export var ConsumerVerificationResults;
(function (ConsumerVerificationResults) {
    ConsumerVerificationResults["VERIFIED"] = "01";
    ConsumerVerificationResults["NOT_VERIFIED"] = "02";
})(ConsumerVerificationResults || (ConsumerVerificationResults = {}));
